/**
 * Created by Florin David on 05/04/2017.
 */
import { dispatch } from 'lib/store'

import {
  ADD_CHAT_ENTRY,
  CLEAR_GENERIC_APP_ERROR,
  SET_FETCHING_RESPONSE,
  SET_GENERIC_APP_ERROR,
  SET_OFFLINE,
  SET_PRODUCT_FAMILY,
  SET_QUESTION,
  SET_SESSION_ID,
  SET_SMALL_SCREEN_SIZE,
  SET_UPDATE_IN_PROGRESS,
  SET_UPDATE_READY,
} from 'constants/action-types'
import { ProductFamily } from 'types/product-family'
import { gqlRequest } from 'lib/request'
import { getProductFamily, getQuestion, getSessionId } from 'selectors/app'

export const setUpdateInProgress = (inProgress: boolean): void =>
  dispatch(SET_UPDATE_IN_PROGRESS, inProgress)

export const setUpdateReady = (ready: boolean): void =>
  dispatch(SET_UPDATE_READY, ready)

/**
 * Set generic error
 *
 * @param {Object} params
 * @param {String} params.title
 * @param {String} params.message
 * @param {String} params.bodyClassName
 * @param {String} params.stackClassName
 * @param {Object} params.confirm
 * @param {String} params.confirm.label
 * @param {String} params.confirm.nextUrl
 *
 * @return {Promise.<*>}
 */
export const setGenericError = (params: GenericError): void => {
  const { bodyClassName, stackClassName, title, message, messageId, confirm } =
    params

  return dispatch(SET_GENERIC_APP_ERROR, {
    bodyClassName,
    stackClassName,
    title,
    message,
    messageId,
    confirm,
  })
}

export const closeGenericError = (): void => {
  dispatch(CLEAR_GENERIC_APP_ERROR)
}

export const setOffline = (offline: boolean): void => {
  dispatch(SET_OFFLINE, offline)
}

export const setSmallScreenSize = (screenSizeSmall: boolean): void => {
  dispatch(SET_SMALL_SCREEN_SIZE, screenSizeSmall)
}

export const setProductFamily = (productFamily: ProductFamily): void => {
  dispatch(SET_PRODUCT_FAMILY, productFamily)
}

export const setQuestion = (question: string): void => {
  dispatch(SET_QUESTION, question)
}

export const askQuestion = async (): Promise<void> => {
  dispatch(SET_FETCHING_RESPONSE, true)
  const question = getQuestion()
  const sessionId = getSessionId()
  try {
    const response: GqlResponse<{ queryModel: QueryResponse }> =
      await gqlRequest(
        `query queryMode ($filter: QueryModelFilter!){
          queryModel(
            filter: $filter
          ) {
            text
            references
            sessionId
          }
        }`,
        {
          filter: {
            prompt: question,
            productFamily: getProductFamily(),
            sessionId,
          },
        },
      )
    dispatch(ADD_CHAT_ENTRY, {
      datetime: Date.now(),
      question: question,
      response: response.queryModel,
    })
  } finally {
    dispatch(SET_FETCHING_RESPONSE, false)
  }
}

export const clearSession = (): void => {
  dispatch(SET_SESSION_ID, null)
}
